import { forwardRef, useImperativeHandle, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useFormContext } from "react-hook-form";

import ErrorMessage from "../ErrorMessage";

export interface RecaptchaHandle {
  reset: () => void;
}

const Recaptcha = forwardRef<RecaptchaHandle>((_, ref) => {
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const {
    register,
    setValue,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  register("recaptcha", {
    required: "Please verify that you are not a robot.",
  });

  useImperativeHandle(ref, () => ({
    reset: () => {
      recaptchaRef.current?.reset();
      setValue("recaptcha", null);
    },
  }));

  const handleOnChange = (value: string | null) => {
    clearErrors("recaptcha");
    setValue("recaptcha", value);
  };

  const error = errors?.["recaptcha"]?.message;

  return (
    <div className="sm:col-span-4">
      <ReCAPTCHA
        ref={recaptchaRef}
        onChange={handleOnChange}
        sitekey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}
      />
      {error && (
        <ErrorMessage id="recaptcha-anchor-error">{error}</ErrorMessage>
      )}
    </div>
  );
});

Recaptcha.displayName = "Recaptcha";

export default Recaptcha;
